import React from 'react';
import PropTypes from 'prop-types';
import { UiOrganization } from './Organization.style';
import { OrganizationTable } from 'components';


/**
 * 在這邊描述這個組件
 */

export const Organization = () => (
  <UiOrganization>
    <OrganizationTable />
  </UiOrganization>
);


Organization.propTypes = {
  children: PropTypes.node,
};


